import { CAMPAIGN_STATES } from "../../../../constants/campaign.constants"
import { setStateType } from "../../../../types/setStateType"
import { campaignData } from "../../store/types/sponsoredProducts"
import { IPlacementDataTable } from "../../types/placement"

interface ISelectCampaignIfNeeded {
  campaignId: number
  placements: IPlacementDataTable[]
  campaignData: campaignData
  setSelectedCampaignIds: setStateType<number[]>
}

export function selectCampaignIfNeeded({
  campaignId,
  placements,
  campaignData,
  setSelectedCampaignIds,
}: ISelectCampaignIfNeeded) {
  const findedCampaign = campaignData.campaigns.find(
    (campaign) => campaign.campaignId === campaignId
  )
  if (!findedCampaign || findedCampaign.campaignStatus === CAMPAIGN_STATES.PAUSED) {
    return
  }

  const hasChanges = placements.some((p) => {
    const newBidAdjustment =
      p.newBidAdjustment !== undefined ? p.newBidAdjustment : p.newbidAdjustment || 0

    const isChanged =
      p.placementModifier !== newBidAdjustment ||
      Number(p.targetCPCAmazon?.toFixed(2) || 0) !== Number(p.targetCPC?.toFixed(2) || 0)

    const isAllowedByFilter =
      !campaignData.excludeAdjustedCampaign ||
      !campaignData.updatedCompanyIdsToday.includes(String(campaignId))
    return isChanged && isAllowedByFilter
  })

  if (hasChanges) {
    setSelectedCampaignIds((prev) => {
      if (prev.includes(campaignId)) return prev
      return [...prev, campaignId]
    })
  }
}
